function normalizeRidValue(value) {
  if (value === null || typeof value === 'undefined') {
    return null;
  }
  var str = typeof value === 'string' ? value : String(value);
  str = str.trim();
  if (!str) {
    return null;
  }
  if (str.charAt(0) !== '#') {
    str = '#' + str;
  }
  return /^#\d+:\d+$/.test(str) ? str : null;
}

function getContextRid(elementRecord) {
  if (!elementRecord) return null;
  if (elementRecord.locationContextRid) {
    var normalized = normalizeRidValue(elementRecord.locationContextRid);
    if (normalized) {
      return normalized;
    }
  }
  if (elementRecord.form && typeof elementRecord.form.locationContextRid === 'function') {
    return normalizeRidValue(elementRecord.form.locationContextRid());
  }
  return null;
}

function getEquipmentLocationRid(elementRecord) {
  if (!elementRecord) {
    return null;
  }

  var overrideRid = getContextRid(elementRecord);
  if (overrideRid) {
    return overrideRid;
  }

  var locationRecord = null;
  var locationAttr = elementRecord.location;

  if (typeof locationAttr === 'function') {
    try {
      locationRecord = locationAttr();
    } catch (error) {
      locationRecord = null;
    }
  } else if (locationAttr && typeof locationAttr === 'object') {
    locationRecord = locationAttr;
  }

  if (locationRecord && locationRecord['@rid']) {
    return locationRecord['@rid'];
  }

  if (elementRecord.parentRid) {
    return elementRecord.parentRid;
  }

  return null;
}

module.exports = getEquipmentLocationRid;
